import { Link } from "react-router-dom";
import styles from "./main.module.css";

interface SideBarItemsProps {
  icon: React.ReactNode;
  name: string;
  link: string;
  isActive: boolean
}

const SideBarItem: React.FC<SideBarItemsProps> = ({ icon, name, link, isActive }) => {
  return (
    <Link to={link} className={`${styles.sideBarItem} ${isActive ? styles.active : '' }`} >
      {icon}
      <span>{name}</span>
    </Link>
  );
};

export default SideBarItem;
